
export enum CommissionPayoutStatus {
    CREATED = "CREATED",
    PAYABLE = "PAYABLE",
    PAID_PRODUCER = "PAID_PRODUCER",
    PAID_OPERATOR = "PAID_OPERATOR",
    INVOICED = "INVOICED",
    ARCHIVED = "ARCHIVED"
}

export enum InvoicePayoutStatus {
    PAYABLE = "PAYABLE",
    PAID_PRODUCER = "PAID_PRODUCER",
    PAID_OPERATOR = "PAID_OPERATOR"
}